export const FrequentlyQuestionsInfo = process.env.LOCALE === "es-EC" ? [
  {
    title: '¿Puedo ganar varias veces durante la actividad?',
    description: `No, si gana una etapa no puede volver a ganar premio individual.`,
  },
  {
    title: '¿Cómo es la mecánica?',
    description: `Ingresando claves de los productos Nosotras.`,
  },
  {
    title: '¿Cuántas veces puedo ingresar claves? ',
    description: `Las veces que quieran, ganan las personas que más claves ingresen`,
  },
  {
    title: '¿El premio se puede cambiar?',
    description: `No es canjeable`,
  },
  {
    title: '¿Puedo ganar varias veces?',
    description: `No, solo se puede ganar 1 vez un premio individual.`,
  },
  {
    title: '¿Qué pasa si no guardo los empaques?',
    description: `No podrás reclamar tu premio, debes guardarlos todos porque al final serán contados y entregados a nuestro programa de recolección de empaques.`,
  },
  {
    title: '¿Me valen los puntos o las claves?',
    description: `En esta actividad solo tendremos en cuenta la cantidad de claves que ingreses, si ingresas la clave de un empaque que vale x 100 puntos, sólo valdrá como una clave, es decir, los puntos no tendrán incidencia en esta actividad.`,
  },
  {
    title: '¿Puedo ingresar todas las claves de los productos?',
    description: `Sí, puedes ingresar todos los productos que tengan clave personal. Por ejemplo los de muestra gratis y de empaque individual no son válidos porque no tienen clave personal.`,
  },
  {
    title: '¿Dónde está la clave personal de los empaques?',
    description: `En el lateral, respaldo etc… (sacarlo de sección mis puntos)`,
  },
  {
    title: 'Si no gano ningún premio, ¿estos puntos me sirven para otra actividad?',
    description: `No, estas claves ya no servirán para otras actividades.`,
  },
]
: process.env.LOCALE === "es-PE" ? [
  {
    title: '¿Puedo ganar varias veces durante la actividad?',
    description: `No, si gana una de manera individual, no puede volver a ganar, pero sí podría ganar con su colegio el premio mayor.`,
  },
  {
    title: '¿Los puntos que registro, suman para mi y para mi colegio al mismo tiempo?',
    description: `Sí, te suman para ti y para tu colegio.`,
  },
  {
    title: '¿Cómo es la mecánica?',
    description: `Ingresando claves de los productos Nosotras`,
  },
  {
    title: '¿Cuántas veces puedo ingresar claves?',
    description: `Las veces que quieran, ganan las personas que más claves ingresen.`,
  },
  {
    title: 'Si gano yo pero mi colegio no, ¿igual recibo mi premio?',
    description: ` Sí, porque por eso hay premios individuales y un premio grupal.`,
  },
  {
    title: '¿Si mi colegio no aparece dentro de la lista no puedo participar?',
    description: `Sí puedes participar, solo debes registrar a tu colegio aquí (link de soporte) o instrucciones de como hacerlo botón del portal, contactar con los canales de atención.`,
  },
  {
    title: '¿Si no quiero participar con mi colegio igual puedo participar?',
    description: `Sí puedes participar de forma individual por alguno de los premios, pero el premio de la fiesta solo se lo gana un colegio`,
  },
  {
    title: '¿El premio se puede cambiar?',
    description: `No es canjeable.`,
  },
  {
    title: '¿Puedo ganar varias veces?',
    description: `No, solo se puede ganar 1 vez un premio individual.`,
  },
  {
    title: '¿Qué pasa si no guardo los empaques?',
    description: `No podrás reclamar tu premio, debes guardarlos todos porque al final serán contados y entregados a nuestro programa de recolección de empaques.`,
  },
  {
    title: '¿Me valen los puntos o las claves?',
    description: `En esta actividad solo tendremos en cuenta la cantidad de claves que ingreses, si ingresas la clave de un empaque que vale x 100 puntos, solo valdrá como una clave, es decir, los puntos no tendrán incidencia en esta actividad.`,
  },
  {
    title: '¿Puedo ingresar todas las claves de los productos?',
    description: `Sí, puedes ingresar todos los productos que tengan clave personal. Por ejemplo los de muestra gratis y de empaque individual no son válidos porque no tienen clave personal.`,
  },
  {
    title: '¿Dónde está la clave personal de los empaques?',
    description: `En el lateral, respaldo etc… (sacarlo de sección mis puntos).`,
  },
  {
    title: 'Si no gano ningún premio, ¿estos puntos me sirven para otra actividad?',
    description: `No, estas claves ya no servirán para otras actividades.`,
  },
]
:
[
  {
    title: '¿Puedo ganar varias veces durante la actividad?',
    description: `No, si gana una etapa no puede volver a ganar premio
    individual pero sí podría ganar con su colegio el premio mayor`,
  },
  {
    title:
      '¿Las claves  que registro, suman para mi y para mi colegio al mismo tiempo?',
    description: `Sí, te suman para ti y para tu colegio.`,
  },
  {
    title: '¿Cómo es la mecánica?',
    description: `Ingresando claves de los productos Nosotras, guardando
    los empaques e ingresando la mayor cantidad de claves que puedas
    para que ganes muchos premios.    `,
  },
  {
    title: '¿Cuántas veces puedo ingresar claves personales de empaques de Nosotras?',
    description: `Las veces que quieran, ganan las personas que más claves ingresen`,
  },
  {
    title: 'Si gano yo pero mi colegio no, ¿igual recibo mi premio?',
    description: `Sí, porque por eso hay premios individuales y un premio grupal.`,
  },
  {
    title: '¿Si mi colegio no aparece dentro de la lista no puedo participar?',
    description: `Sí puedes participar, solo debes registrar a tu colegio aquí 
    (link de soporte) o instrucciones de como hacerlo.`,
  },
  {
    title: '¿Si no registré mi colegio en un principió, puedo registrarlo después?',
    description: `Claro que puedes, siguiendo las instrucciones del juego`,
  },
  {
    title: '¿Si no quiero participar con mi colegio igual puedo participar?',
    description: `Sí puedes participar de forma individual por alguno de los premios,
     pero el premio de la fiesta solo se lo gana un colegio`,
  },
  {
    title: '¿El premio se puede cambiar?',
    description: `No es canjeable`,
  },
  {
    title: 'Si ya gané en alguna de las 2 primeras etapas, ¿mis claves personales siguen sumando al colegio o se eliminan?',
    description: `Siguen sumando para el premio mayor pero no suman para otro premio individual.`,
  },
  {
    title: '¿Puedo ganar varias veces?',
    description: `No, solo se puede ganar 1 vez un premio individual.`,
  },
  {
    title: '¿Qué pasa si no guardo los empaques?',
    description: `No podrás reclamar tu premio, debes guardarlos todos porque al
      final serán contados y entregados a nuestro programa de recolección de empaques.
     Recuerda que son tus empaques y los de todas las usuarias que sumen claves para el colegio.`,
  },
  {
    title: '¿Me valen los puntos o las claves?',
    description: `En esta actividad solo tendremos en cuenta la cantidad de claves que ingreses,
     si ingresas la clave de un empaque que vale x 100 puntos, solo valdrá como una clave, es decir,
      los puntos no tendrán incidencia en esta actividad.`,
  },
  {
    title: '¿Puedo ingresar todas las claves de los productos?',
    description: `Sí, puedes ingresar todos los productos que tengan clave personal.
     Por ejemplo los de muestra gratis y de empaque individual no son válidos porque
      no tienen clave personal.`,
  },
  {
    title: '¿Dónde está la clave personal de los empaques?',
    description: `En el lateral, respaldo etc… (sacarlo de sección mis puntos)`,
  },
  {
    title: 'Si no gano ningún premio, ¿estos puntos me sirven para otra actividad?',
    description: `No, estas claves ya no servirán para otras actividades.`,
  },
  {
    title: '¿Qué pasa si yo sumé una clave a mi participación individual y no la sumé en ese momento al colegio?',
    description: `Cuando registres tus claves, debes estar segura de registrarlas correctamente.
     Tus claves personales se sumarán a tu colegio cuando lo registres y es en este momento
      cuando comienzas a sumar tus claves personales al colegio, de lo contrario, se quedarán
       solo como claves individuales`,
  },
]
